export const MAX_SOURCE_BYTES = 20 * 1024 * 1024;
export const MAX_JPEG_BYTES = 3.5 * 1024 * 1024;

export type InvoiceFileKind = 'image' | 'pdf';

export type InvoiceFileCheck =
  | { ok: true; kind: InvoiceFileKind }
  | { ok: false; error: string };

const IMAGE_MIME = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/webp']);
const IMAGE_EXT = /\.(jpe?g|png|webp)$/i;

export function classifyInvoiceFile(file: File): InvoiceFileCheck {
  if (!file || file.size <= 0) {
    return { ok: false, error: 'הקובץ ריק.' };
  }
  if (file.size > MAX_SOURCE_BYTES) {
    return { ok: false, error: 'הקובץ גדול מדי. הגודל המרבי הוא 20MB.' };
  }

  const name = (file.name || '').toLowerCase();
  const type = (file.type || '').toLowerCase();

  if (type === 'image/heic' || type === 'image/heif' || name.endsWith('.heic') || name.endsWith('.heif')) {
    return { ok: false, error: 'קבצי HEIC אינם נתמכים. שמרו כ-JPEG או PNG, או העלו PDF.' };
  }

  if (type === 'application/pdf' || name.endsWith('.pdf')) {
    return { ok: true, kind: 'pdf' };
  }

  if (IMAGE_MIME.has(type) || IMAGE_EXT.test(name)) {
    return { ok: true, kind: 'image' };
  }

  return { ok: false, error: 'יש לבחור קובץ JPEG, PNG, WebP או PDF.' };
}
